/**
 * 图标系统
 * ---------------------------------------------------------------------------
 * 24×24 描边图标，路径数据原样取自《高保真 UI 设计稿 V1.1》第 03 节。
 * 全部内联，不引第三方图标库：
 *   - 视觉上和设计稿完全一致（第三方库的线宽和圆角对不上）；
 *   - 门店弱网环境下没有额外请求；
 *   - 打包体积只包含真正用到的这几十个图标。
 *
 * 新增图标：往下面的 ICON_PATHS 加一条，key 用语义名（不要用 icon1 这种）。
 */

const ICON_PATHS = {
  home: '<path d="M3.5 10.6 12 3.5l8.5 7.1"/><path d="M5.8 9.4V20h12.4V9.4"/><path d="M10 20v-5h4v5"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  receipt:
    '<path d="M5.5 3h13v18l-2.6-1.5L13.3 21l-2.3-1.5L8.7 21l-2.6-1.5H5.5z"/><path d="M9 8.5h6M9 12.5h6"/>',
  users:
    '<path d="M16 19.5V18a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v1.5"/><circle cx="9.5" cy="8" r="3.2"/><path d="M21 19.5V18a4 4 0 0 0-3-3.87M16.2 4.9a4 4 0 0 1 0 7.2"/>',
  clock: '<circle cx="12" cy="12" r="8.6"/><path d="M12 7.2V12l3.3 2"/>',
  staff:
    '<rect x="3" y="5" width="18" height="14" rx="2.2"/><circle cx="8.2" cy="11" r="2.1"/><path d="M4.8 16.4c.7-1.7 2-2.5 3.4-2.5s2.7.8 3.4 2.5M14.5 10h4M14.5 14h2.8"/>',
  percent:
    '<circle cx="7" cy="7" r="2.8"/><circle cx="17" cy="17" r="2.8"/><path d="M19 5 5 19"/>',
  scissors:
    '<circle cx="6.5" cy="6.5" r="2.6"/><circle cx="6.5" cy="17.5" r="2.6"/><path d="M8.6 8.4 20 19.5M20 4.5 8.6 15.6"/>',
  ticket:
    '<path d="M3 8.5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2V10a2 2 0 0 0 0 4v1.5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V14a2 2 0 0 0 0-4z"/><path d="M13 7v2M13 15v2"/>',
  box: '<path d="M3.6 7.6 12 3.4l8.4 4.2v8.8L12 20.6l-8.4-4.2z"/><path d="M3.6 7.6 12 11.8m0 0 8.4-4.2M12 11.8v8.8"/>',
  ledger:
    '<path d="M4 5a2 2 0 0 1 2-2h13v18H6a2 2 0 0 1-2-2z"/><path d="M4 17.5a2 2 0 0 1 2-2h13"/><path d="M8.5 7.5h6"/>',
  chart: '<path d="M4 20V11M9.7 20V5M15.3 20v-6M21 20V8"/>',
  sliders:
    '<path d="M4 7h6M15 7h5M4 12h11M19 12h1M4 17h3M12 17h8"/><circle cx="12.5" cy="7" r="2.2"/><circle cx="17" cy="12" r="2.2"/><circle cx="9.5" cy="17" r="2.2"/>',
  gear: '<circle cx="12" cy="12" r="3"/><path d="M19.4 14.5a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1 1.56V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.56 1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.7 1.7 0 0 0 .34-1.87 1.7 1.7 0 0 0-1.56-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.56-1.1 1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.7 1.7 0 0 0 1.87.34H9a1.7 1.7 0 0 0 1-1.56V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.56 1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.7 1.7 0 0 0-.34 1.87V9a1.7 1.7 0 0 0 1.56 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"/>',
  cloud:
    '<path d="M7 18.5h10.2a4.1 4.1 0 0 0 .5-8.18 6.1 6.1 0 0 0-11.75 1.6A3.7 3.7 0 0 0 7 18.5z"/>',
  bell: '<path d="M18 8.8a6 6 0 1 0-12 0c0 5-2.2 6.4-2.2 6.4h16.4S18 13.8 18 8.8z"/><path d="M10.3 19a2 2 0 0 0 3.4 0"/>',
  help: '<circle cx="12" cy="12" r="8.6"/><path d="M9.7 9.4a2.4 2.4 0 1 1 3.2 2.3c-.6.25-.9.8-.9 1.45v.5"/><path d="M12 16.6h.01"/>',
  search: '<circle cx="11" cy="11" r="6.8"/><path d="M20 20l-4.2-4.2"/>',
  chev: '<path d="m9 5 7 7-7 7"/>',
  chevd: '<path d="m5 9 7 7 7-7"/>',
  close: '<path d="M6.5 6.5 17.5 17.5M17.5 6.5 6.5 17.5"/>',
  check: '<path d="m5 12.5 4.6 4.6L19 6.8"/>',
  arrow: '<path d="M4 12h15m-6.2-6.2L19 12l-6.2 6.2"/>',
  wallet:
    '<path d="M3 8a2 2 0 0 1 2-2h11.5"/><rect x="3" y="6" width="18" height="13" rx="2.2"/><path d="M21 11h-4a2 2 0 0 0 0 4h4"/>',
  trend:
    '<path d="m3.5 16.5 5.5-5.5 3.5 3.5 8-8"/><path d="M20.5 6.5h-4.2M20.5 6.5v4.2"/>',
  alert:
    '<path d="M10.3 4.3 2.7 17.5A2 2 0 0 0 4.4 20.5h15.2a2 2 0 0 0 1.7-3L13.7 4.3a2 2 0 0 0-3.4 0z"/><path d="M12 9.5v4M12 17h.01"/>',
  // 客服耳麦：售后工单
  headset:
    '<path d="M4.5 14.5v-2.2a7.5 7.5 0 0 1 15 0v2.2"/><rect x="3" y="13.5" width="3.6" height="6" rx="1.6"/><rect x="17.4" y="13.5" width="3.6" height="6" rx="1.6"/><path d="M19.2 19.5v.6a2.4 2.4 0 0 1-2.4 2.4H13"/>',
  lock: '<rect x="5" y="10.5" width="14" height="9.5" rx="2.2"/><path d="M8.4 10.5V7.8a3.6 3.6 0 1 1 7.2 0v2.7"/>',
  mobile:
    '<rect x="6.5" y="2.5" width="11" height="19" rx="2.6"/><path d="M10.5 18.4h3"/>',
  message: '<path d="M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H9l-5 4.5z"/>',
  calendar:
    '<rect x="3.4" y="5.4" width="17.2" height="15.2" rx="2.2"/><path d="M3.4 10h17.2M8 3.4v4M16 3.4v4"/>',
  coin: '<circle cx="12" cy="12" r="8.6"/><path d="M12 7v10"/><path d="M14.6 9.4c-.6-.9-1.6-1.3-2.6-1.3-1.3 0-2.3.7-2.3 1.9 0 2.5 5.2 1.5 5.2 4 0 1.2-1.1 1.9-2.5 1.9-1.1 0-2.2-.4-2.8-1.4"/>',
  user: '<circle cx="12" cy="8.2" r="3.8"/><path d="M4.8 20.5a7.4 7.4 0 0 1 14.4 0"/>',
  store:
    '<path d="M4.5 10V20.5h15V10"/><path d="M2.8 9.6 4.6 3.5h14.8l1.8 6.1a2.9 2.9 0 0 1-5.4 1.5 2.9 2.9 0 0 1-4.8 0 2.9 2.9 0 0 1-4.8 0 2.9 2.9 0 0 1-3.4-1.5z"/><path d="M9.5 20.5v-5.5h5v5.5"/>',
  bulb: '<path d="M9.2 18h5.6M10.2 21h3.6"/><path d="M12 3a6 6 0 0 0-3.5 10.85c.6.45 1 1.2 1 2.05h5c0-.85.4-1.6 1-2.05A6 6 0 0 0 12 3z"/>',
  print:
    '<path d="M7 9V3.5h10V9"/><rect x="3.5" y="9" width="17" height="7.5" rx="2"/><path d="M7 14h10v6.5H7z"/>',
  filter: '<path d="M3.5 5.5h17l-6.6 7.8v5.4l-3.8 2v-7.4z"/>',
  edit: '<path d="M15.5 4.5 19.5 8.5 9 19H5v-4z"/><path d="M13.5 6.5 17.5 10.5"/>',
  refresh: '<path d="M20.5 12a8.5 8.5 0 1 1-2.6-6.1"/><path d="M20.5 4v5h-5"/>',
  export:
    '<path d="M12 15.5V3.8M12 3.8 8.2 7.6M12 3.8l3.8 3.8"/><path d="M4.5 14.5v4a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-4"/>',
  star: '<path d="m12 3.5 2.6 5.4 5.9.85-4.25 4.15 1 5.9L12 17.05 6.75 19.8l1-5.9L3.5 9.75l5.9-.85z"/>',
  gift: '<rect x="3.5" y="8.5" width="17" height="4" rx="1.2"/><path d="M5 12.5v8h14v-8M12 8.5v12"/><path d="M12 8.5S10.5 3.5 8 3.5a2.3 2.3 0 0 0 0 5zM12 8.5s1.5-5 4-5a2.3 2.3 0 0 1 0 5z"/>',
  play: '<path d="M7 4.8 19 12 7 19.2z"/>',
  wifi: '<path d="M2.6 8.6a14.6 14.6 0 0 1 18.8 0"/><path d="M5.7 12.1a10 10 0 0 1 12.6 0"/><path d="M8.8 15.5a5.4 5.4 0 0 1 6.4 0"/><path d="M12 19h.01"/>',
  usb: '<circle cx="9" cy="19.2" r="1.9"/><path d="M9 17.3V6.4"/><path d="M5.9 9.5 9 6.4l3.1 3.1"/><path d="M14.2 5.2h4.3v3.1h-4.3z"/><path d="M16.35 8.3v5.6a3 3 0 0 1-3 3H9"/>',
  download:
    '<path d="M12 3.6v11.8M8.2 11.6l3.8 3.8 3.8-3.8"/><path d="M4.6 16v2.9a2 2 0 0 0 2 2h10.8a2 2 0 0 0 2-2V16"/>',
  monitor:
    '<rect x="2.6" y="4" width="18.8" height="13" rx="2.2"/><path d="M8.6 21h6.8M12 17v4"/>',
  trash:
    '<path d="M4.5 6.5h15M9.5 6.5V4.8a1.3 1.3 0 0 1 1.3-1.3h2.4a1.3 1.3 0 0 1 1.3 1.3v1.7"/><path d="M6.5 6.5 7.4 19a1.6 1.6 0 0 0 1.6 1.5h6a1.6 1.6 0 0 0 1.6-1.5l.9-12.5"/><path d="M10.5 10v6.5M13.5 10v6.5"/>',
  dot: '<circle cx="12" cy="12" r="3"/>',
} as const;

export type IconName = keyof typeof ICON_PATHS;

export type IconProps = {
  name: IconName;
  /** 边长，像素。侧栏 16、卡片 18、指标卡 20 */
  size?: number;
  /** 线宽。小尺寸图标可以调细一点保持视觉重量一致 */
  strokeWidth?: number;
  className?: string;
};

/**
 * 图标颜色跟随父级 color（stroke="currentColor"），
 * 所以改颜色直接给外层加 text-brand 之类的类名即可。
 */
export function Icon({
  name,
  size = 18,
  strokeWidth = 1.9,
  className,
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
      // 路径数据是本文件里的常量，永远不会掺入用户输入，
      // 用 innerHTML 是为了让图标表保持"一行一个图标"的可维护形态。
      dangerouslySetInnerHTML={{ __html: ICON_PATHS[name] ?? ICON_PATHS.dot }}
    />
  );
}
